import { useSearchParams } from "react-router-dom";

const ReferralsPage = () => {
  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");
  // <Route path="/referral/:code" element={<ReferralsPage />} />
  const openApp = () => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const appScheme = `minimis://referral?code=${code}`;
    const appStoreURL =
      "https://apps.apple.com/pk/app/minimis-phone/id6742091169";

    if (isIOS) {
      const now = Date.now();
      setTimeout(() => {
        if (Date.now() - now < 1600) {
          window.location.href = appStoreURL;
        }
      }, 1200);
      window.location.href = appScheme;
    } else {
      window.location.href = appStoreURL;
    }
  };

  return (
    <div style={styles.container}>
      <h1>Welcome to Minimis</h1>
      <p>
        Tap the button below to open the app. If you don’t have it, you’ll be
        redirected to the App Store.
      </p>
      <button onClick={openApp} style={styles.button}>
        Open App
      </button>
    </div>
  );
};

const styles = {
  container: {
    padding: "2rem",
    textAlign: "center",
    fontFamily: "sans-serif",
  },
  button: {
    backgroundColor: "#007aff",
    color: "white",
    border: "none",
    padding: "1rem 2rem",
    borderRadius: "8px",
    fontSize: "1rem",
    cursor: "pointer",
  },
};

export default ReferralsPage;
